<template>
  <div>
    <bread-crumb></bread-crumb>
    <role-dialog
      :dialogFormVisible="dialogFormVisible"
      :checkboxList="checkboxList"
      :parentList="parentList"
      @changeDialog="changeDialog"
      :formData="authorityForm"
      @submit="submit"
    ></role-dialog>
    <top-bar
      :isShowSelect="isShowSelect"
      placeholder="请选择所属业务"
      :data="data"
      :clickAddButton="clickAddButton"
    ></top-bar>
    <base-table
      :tableData="tableData"
      @handleClick="TabhandleClick"
    ></base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    >
    </pagination>

    <modal
      :width="width"
      :isShow.sync="formDialog"
      title="提示"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="ClickHandler"
    >
      <div class="dialog-conter">是否确认删除</div>
    </modal>
  </div>
</template>

<script>
import pagination from "../../../../components/pagination";
import modal from "../../../../components/modal";
import topBar from "../../../../components/topBar";
import baseTable from "../../../../components/baseTable";
import breadCrumb from "../../../../components/breadCrumb";
// import baseDialogPlus from "../../components/baseDialogPlus";
import RoleDialog from "../../components/roleDialog.vue";
import {
  pageContentRole,
  listContentUserManPermissions,
  saveOrUpdateContentRole,
  getContentRole,
  deleteContentRole,
} from "../../../../api/man";
export default {
  name: "roleManage",
  data() {
    return {
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      width: "414px",
      formDialog: false,
      isShowBtn: [true, true],
      btnText: ["取消", "确认"],
      tableVal: {},
      authorityForm: {
        roleName: "",
        roleType: "",
        description: "",
        contentPermissionIds: [],
      },
      dialogFormVisible: false,
      isShowSelect: false,
      data: [],
      checkboxList: [],
      parentList: [],
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "角色ID",
            prop: "id",
          },
          {
            label: "角色名称",
            prop: "roleName",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
          {
            label: "创建人",
            prop: "createUser",
          },
        ],
        tableType: 8,
      },
    };
  },
  components: {
    baseTable,
    topBar,
    breadCrumb,
    RoleDialog,
    modal,
    pagination,
  },
  created() {
    this.pageContentRole();
    this.listContentUserManPermissions();
  },
  methods: {
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageContentRole();
    },
    ClickHandler(type) {
      if (type === "one") {
        this.formDialog = false;
      } else if (type === "two") {
        this.deleteContentRole(this.tableVal.id);
        this.formDialog = false;
      }
    },
    changeDialog() {
      this.tableVal = {};
      this.dialogFormVisible = false;
    },
    clickAddButton() {
      this.tableVal = {};
      this.authorityForm.roleName = "";
      this.authorityForm.roleType = "";
      this.authorityForm.description = "";
      this.authorityForm.contentPermissionIds = [];
      this.parentList = [];
      this.dialogFormVisible = true;
    },
    TabhandleClick(data) {
      this.tableVal = data.val;
      if (data.type === "edit") {
        this.authorityForm.roleName = data.val.roleName;
        this.getContentRole(data.val.id);
        this.dialogFormVisible = true;
      } else if (data.type === "delete") {
        // this.deleteContentRole(data.val.id)
        this.formDialog = true;
      }
    },
    //
    submit(data) {
      if (this.authorityForm.roleName === "") {
        return this.$message({
          message: "角色信息必填",
          type: "warning",
        });
      } else {
        this.authorityForm.contentPermissionIds = data;
        this.saveOrUpdateContentRole();
        this.dialogFormVisible = false;
      }
    },
    // 获取用户权限
    getContentRole(id) {
      getContentRole({
        id: id,
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        this.parentList = res.contentPermissionIds;
      });
    },
    // 权限列表
    listContentUserManPermissions() {
      listContentUserManPermissions({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        this.checkboxList = res;
      });
    },
    // 新增或修改
    saveOrUpdateContentRole() {
      saveOrUpdateContentRole({
        id: this.tableVal.id === undefined ? "" : this.tableVal.id,
        roleName: this.authorityForm.roleName,
        description: "",
        contentPermissionIds: this.authorityForm.contentPermissionIds,
        tenantId: this.$commonJs.getTenantId(),
      })
        .then((res) => {
          this.pageContentRole();
        })
        .catch((err) => {
          if (err.code === "2303") {
            this.$message.error(err.msg);
          }
        });
    },
    // 删除
    deleteContentRole(id) {
      deleteContentRole({
        id: id,
        tenantId: this.$commonJs.getTenantId(),
      })
        .then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
          }
          this.pageContentRole();
        })
        .catch((err) => {
          if (err.code === "2300") {
            this.$message.error(err.msg);
          }
        });
    },
    // 列表页
    pageContentRole() {
      let vm = this;
      pageContentRole({
        tenantId: this.$commonJs.getTenantId(),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      }).then((res) => {
        vm.tableData.tableList.splice(0, vm.tableData.tableList.length);
        res.data.map((item) => {
          vm.tableData.tableList.push(item);
        });
        vm.paginationDataProduct.total = res.totalCount;
        vm.paginationDataProduct.currentPage = res.pageNo;
        vm.paginationDataProduct.pageSize = res.pageSize;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-conter {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 0px;
  text-align: center;
}
// :deep(.el-button--text) {
//   color: #266CEE;
// }
</style>
